module.exports = __webpack_public_path__ + "assets/17ae02ae7415e423aa0d56434c5fa202.png";